import React, { useState } from 'react';
import style from '../css/Login.module.css';
import logo from '../images/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios'; // If you're using axios. Use fetch if preferred.

function Register() {
	const [step, setStep] = useState(1);
	const [formData, setFormData] = useState({
		name: '',
		phone: '',
		email: '',
		password: '',
		confirmPassword: '',
	});
	const [otp, setOtp] = useState('');

	const navigate = useNavigate();

	const handleChange = (e) => {
		setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const handleSendOtp = async () => {
		if (formData.password !== formData.confirmPassword) {
			alert('Passwords do not match');
			return;
		}
		if (!formData.email || !formData.name || !formData.phone) {
			alert('Please fill in all required fields');
			return;
		}
		try {
			const res = await axios.post(
				'https://hometech-repairs.in/customerDB/send_otp.php',
				{ email: formData.email }
			);
			if (res.data.status) {
				alert('OTP sent to your email');
				setStep(2);
			} else {
				alert(res.data.msg);
			}
		} catch (err) {
			console.error(err);
			alert('Failed to send OTP');
		}
	};

	const handleRegister = async () => {
		try {
			const res = await axios.post(
				'https://hometech-repairs.in/customerDB/verify_otp_and_register.php',
				{
					...formData,
					otp,
				}
			);
			if (res.data.status) {
				alert(res.data.msg);
				navigate('/');
			}
		} catch (err) {
			console.error(err);
			alert('Failed to register');
		}
	};

	return (
		<div className={style.main}>
			{/* <div>
				<img src={logo} alt="" className={style.img} />
			</div> */}

			{/* register */}
			{step === 1 && (
				<div className={style.container}>
					<h1 className={style.text}> Register </h1>

					<input
						type="text"
						placeholder="Name"
						name="name"
						value={formData.name}
						onChange={handleChange}
						className={style.input}
					/>
					<input
						type="text"
						placeholder="Phone Number"
						name="phone"
						value={formData.phone}
						onChange={handleChange}
						className={style.input}
					/>
					<input
						type="text"
						placeholder="E-mail ID"
						name="email"
						value={formData.email}
						onChange={handleChange}
						className={style.input}
					/>
					<input
						type="password"
						placeholder="Password"
						name="password"
						value={formData.password}
						onChange={handleChange}
						className={style.input}
					/>
					<input
						type="password"
						placeholder="Confirm Password"
						name="confirmPassword"
						value={formData.confirmPassword}
						onChange={handleChange}
						className={style.input}
					/>

					<Link className={style.button} onClick={handleSendOtp}>
						Next
					</Link>

					<Link to="/" className={style.register}>
						Already have an account? Login
					</Link>
				</div>
			)}

			{/* otp */}
			{step === 2 && (
				<div className={style.container}>
					<h1 className={style.text}> Register </h1>
					<p> Enter OTP sent to your E-mail ID</p>
					<input
						type="text"
						placeholder="OTP"
						value={otp}
						onChange={(e) => setOtp(e.target.value)}
						className={style.input}
					/>

					<Link className={style.button} onClick={handleRegister}>
						Register
					</Link>
				</div>
			)}
		</div>
	);
}

export default Register;
